import { render } from "./TheFooter.vue?vue&type=template&id=e05a4122&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=e05a4122&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e05a4122"

export default script